import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Avatar, DisplayText, TextStyle } from '@superops/ui-design-system';

const DepartmentInsight = (props) => {
  const { chartData } = props;
  if (!chartData) {
    return <>NA</>;
  }

  return (
    <div className="fx fh">
      <div>
        <div className="mb16">
          <DisplayText size="extraLarge">
            <FormattedMessage id="entityAttribute.businessfunction.head" />
          </DisplayText>
        </div>
        {chartData.data.head ? (
          <div className="fx actr g8">
            <Avatar initials={chartData.data.head.name[0]} size="small" />
            <DisplayText size="extraLarge" weight="SemiBold">
              {chartData.data.head.name}
            </DisplayText>
          </div>
        ) : (
          <TextStyle variation="subdued">
            <FormattedMessage id="app.noData.message" />
          </TextStyle>
        )}
      </div>
    </div>
  );
};

export default DepartmentInsight;
